import StingType from "./StingType";
import NumberType from "./NumberType";
import LongNumberType from "./LongNumberType";
import LongNumber_2floatType from "./LongNumber_2floatType";
import SmallNumberType from "./SmallNumberType";
import SmallFloatType from "./SmallFloatType";
import LongFloatType from "./LongFloatType";
import DateType from "./DateType";
import TimeType from "./TimeType";
import MobileType from "./MobileType";
import TelephoneType from "./TelephoneType";
import EmailType from "./EmailType";
import PriceType from "./PriceType";
import ColorType from "./ColorType";
import YearType from "./YearType";
import MonthType from "./MonthType";
import DayType from "./DayType";
import CashBoxType from "./CashBoxType";
import RLookupType from "./RLookupType";
import FileType from "./FileType";
import TextareaType from "./TextareaType";
import SelectBoxType from "./SelectBoxType";
import Computed from "./Computed";
import Editor from "./Editor";

const FormInputTypes = {
  StingType,
  NumberType,
  LongNumberType,
  LongNumber_2floatType,
  SmallNumberType,
  SmallFloatType,
  LongFloatType,
  DateType,
  TimeType,
  MobileType,
  TelephoneType,
  EmailType,
  PriceType,
  ColorType,
  YearType,
  MonthType,
  DayType,
  CashBoxType,
  RLookupType,
  FileType,
  TextareaType,
  SelectBoxType,
  Computed,
  Editor,
}

export default FormInputTypes